export default __webpack_public_path__ + "static/Florida-ab4abbd4fbb112fc84a5e3f3d1763afa.webp";